import React from 'react';

import PropTypes from 'prop-types';
import { Icon } from '..';

const CloseTrigger = ({ onClick }) => (
    <div className="nav__trigger">
        <button type="button" onClick={onClick}>
            <Icon name="arrowBackGray" />
        </button>
    </div>
);
CloseTrigger.propTypes = {
    onClick: PropTypes.func.isRequired
};
export default CloseTrigger;
